export default {
  'navBar.home': 'Home',
  'navBar.recognition': 'Regconition',
  'navBar.gift': 'Gift',
  'navBar.profile': 'Profile',
  'navBar.support': 'Support',
  'header.user.appearance': 'Appearance',
  'header.user.login': 'Login',
}